import { useCallback, useEffect, useMemo, useState } from 'react';
import { EventEmitter } from '../events/EventEmitter';

const localStorageController =
  new (class LocalSctorageController extends EventEmitter<{
    update: {
      prop: string;
      value: unknown;
    };
  }> {})();

/**
 * @param prop este nombre define el nombre del localStorage, las modificaciones a este parametro no van a tener efecto.
 */
export function useLocalStorage<T>(
  prop: string,
  defaultValue?: T,
): [T, (newValue: T) => void] {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const actualProp = useMemo(() => prop, []);
  const storageValue = useMemo(
    () => localStorage.getItem(actualProp) as string,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const [value, setValue] = useState<T>(
    storageValue ? (JSON.parse(storageValue) as T) : (defaultValue as T),
  );
  useEffect(() => {
    setValue(JSON.parse(storageValue) as T);
    return localStorageController.on('update', (ev) => {
      if (ev.prop === actualProp) {
        setValue(ev.value as T);
        localStorage.setItem(actualProp, JSON.stringify(ev.value));
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [
    value,
    useCallback(
      (newValue: T) => {
        localStorageController.emit('update', {
          prop: actualProp,
          value: newValue,
        });
      },
      [actualProp],
    ),
  ];
}
